import { render, staticRenderFns } from "./HFshare.vue?vue&type=template&id=527232f4&scoped=true"
import script from "./HFshare.vue?vue&type=script&lang=js"
export * from "./HFshare.vue?vue&type=script&lang=js"
import style0 from "./HFshare.vue?vue&type=style&index=0&id=527232f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527232f4",
  null
  
)

export default component.exports